import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowNarrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 20V4m0 0-6 6m6-6 6 6"
    />
  </svg>
);
SvgArrowNarrowUp.displayName = 'ArrowNarrowUp';
export default SvgArrowNarrowUp;
